import { render, staticRenderFns } from "./GameleoKeywords.vue?vue&type=template&id=63578d07&"
import script from "./GameleoKeywords.vue?vue&type=script&lang=js&"
export * from "./GameleoKeywords.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports